// extracted by mini-css-extract-plugin
export default {"modal":"review-modal_modal__l5V8l","imageWrapper":"review-modal_imageWrapper__T0tZh"};